export default "__VITE_ASSET__BZqsjhPg__"